export enum QuestionModelEnum {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
}
